export default {
  routes: {
    home: "Home",
    login: "Login",
    register: "Register",
    logout: "Logout",

    company: "Company",
    dashboard: "Dashboard",
    application: "Aplications",
    alarm: "Alarmmanagement",

    user: "Users",
    tagdata: "Data",
    tag: "Sensors",
    script: "Script-engine",
    report: "Reports",
    contact: "Contacts",
    apiRef: "API-Documentation",
    shop: "Buy sensors",
    manual: "Manual",
    userEdit: "Account",

    superadmin: "Admin"
  },

  landing: {
    slogan: "VIZUALIZATION MADE EASY",
    or: "OR",
    key: {
      title: "Key features",
      1: "Sensor management",
      2: "Visualization",
      3: "Custom dashboards",
      4: "Alarm management",
      5: "Personnel management",
      6: "Script engine",

      description: {
        1: "Manage sensors for handling data",
        2: "Get your sensor data vizualized the way you like to observe the data",
        3: "Create your own dashboard specialized YOUR area of ​​use",
        4: "Alarm management for critical usecases",
        5: "To manage the personnel of your company",
        6: "Advanced users can use script engine to mainipulate data"
      }
    },

    usecases: {
      title: "Usecases",
      1: "Environment sensors",
      2: "Electicity sensors",
      3: "Movement sensors",
      4: "Temprature sensors",

      description: {
        1: "Great fit for smart farming suloutions like Ljusgarda making use of the portal. The alarm feature of SENSORONLINE is a key to keeping your assets safe.",
        12: "Read more about Ljusgarda",
        2: "Messure current for streetlights in your city. With the script engine to make sense of the data gathered.",
        3: "Messure how many people or cars are going or entering your facility.",
        4: "Ofcourse temprature measurements are a keypart of our platform. Many companies use and keep track of their asset's tempratures."
      }
    },

    help: {
      title: "Contact us",

      sensors: {
        title: "Need to get some new sensors?",
        description: "If you need any help to solve a problem, be it what sensor to use or how you could visualize your data in a better way. Don't be afraid to reach out to us so we can make your life easier. \n You can check out our portfolio of ",
        store: "sensors that we sell at IoT AB."
      },

      api: {
        title: "API for your convinience",
        description: "You can offcourse get or insert data from your other applications to the platform checkout the endpoints "
      },

      contact: {
        title: "Are you interested? Contact us!",
        siencepark: "Skövde Sience Park",
        address: "Kaplansgatan 16B",
        postal: "521 32 Skövde",
        country: "Sweden",
        phoneTitle: "Phone",
        phonenumber: "+46 (0) 500 600 022",
        phonenumber2: "+46 (0) 733 165 100",
        emailTitle: "Email",
        email: "info@sensor-online.se"
      }
    }
  },

  imageMap: {
    chooseTag: "Välj sensor"
  },

  log: {
    type: {
      sms: "SMS",
      app: "Application",
      warning: "Warning",
      error: "Error",
      userevent: "Userevent",
      login: "Login"
    },

    logTable: {
      title: "Log"
    },

    activeAlarms: {
      title: "Active alarms"
    },

    activeUsersTable: {
      title: "Logged in users"
    },

    fields: {
      type: "Type",
      user: "User",
      message: "Message",
      createdAt: "Created",

      status: "Status",
      lastAction: "Event",
      lastSeen: "Timestamp",

      alarm: {
        name: "Name",
        value: "Value",
        messageSent: "Sent notification"
      }
    }
  },
  common: {
    timestamp: "Timestamp",
    lang: "Language",
    error: "An error occured, -try again later",
    edit: "Edit",
    delete: "Delete",
    purge: "Erase",
    submit: "Send",
    create: "Create",
    update: "Update",
    get: "Get",

    search: "Search",
    close: "Close",

    login: "Login",
    register: "Enroll",
    email: "Email",
    password: "Password",
    confirmPassword: "Confim Password",
    newPassword: "New Password",
    forgotPassword: "Forgot Password",

    createdAt: "Created",
    updatedAt: "Updated",

    save: "Save",
    show: "Show",
    updated: "Updated",
    created: "Created",
    deleted: "Erased",
    back: "Return",
    send: "Send",

    add: "Add",

    settings: "Setup",

    noTagOrAppChoosen: "Sensor and/or aplication missing",
    noDataFound: "No date found",
    darkTheme: "Dark theme",

    active: "Active",
    notActive: "Not active",

    sent: "Sent",
    notSent: "Not sent",

    loginOrRegister: "Login or enroll",

    copy: "Kopiera",
    verify: "Are you sure you want to continue?",
    disagree: "No",
    accept: "Yes",

    or: "Or",

    dashboard: "Go to Dashboard",

    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    }
  },

  map: {
    setPosFormTitle: "Choose sensor to change position"
  },

  dashboard: {
    name: "Dashboards",
    copyDeleteTitle: "Delete or copy dashboard",
    createTitle: "Or create a new dashboard",
    chooseTitle: "Choose dashboard",
    chooseDesc:
      "The choice you made will be saved as default dashboard until next time you use the portal. To change or create a new daschboard, press the bluebutton in the bottom right corner.",

    fields: { name: "Name" },
    nameReq: "This filed must be filled in"
  },
  module: {
    create: "Create a new element",
    edit: "Edit element",
    metas: "Attributes",

    meta: {
      label: "Attributes",
      save: "Save attributes",

      valueMatch: "Attribut 1",
      value: "Attribut 2",
      key: "Key",
      icon: "Icon",

      keys: {
        value_match: "Value name",
        icon: "Icon sufix",
        sufix: "Sufix",
        prefix: "Prefix",
        deveui: "Deveui",
        maxheight: "Max height"
      },

      fields: {
        value_match: "Value",
        name: "Name",
        icon: "Icon sufix",
        sufix: "Sufix",
        prefix: "Prefix",
        deveui: "Deveui",
        maxheight: "Max height (ex 300 for 300px)"
      }
    },

    fields: {
      title: "Title",
      types: "Type",
      content: "Content",
      sm: "Size onsmall screen",
      md: "Size on mid size screen",
      min: "Min value",
      max: "Max value",
      image: "Image",
      url: "URL"
    },
    enum: {
      size: { xs: "XSMALL", sm: "SMALL", md: "MEDIUM", lg: "LARGE" },
      types: {
        0: "Chart",
        1: "Gauge",
        2: "Text",
        3: "Image",
        4: "Google Map",
        5: "Companyinformation",
        6: "IFrame",
        7: "SMHI",
        8: "Latest value",
        9: "Raw tabel",
        10: "Multiline Chart",
        11: "Image map"
      }
    }
  },

  weather: {
    title: "SMHI Weatherforcast",
    icon: "Wheater",
    temp: "Temperature",
    windDir: "Winddirection",
    windSpeed: "Wind",
    humidity: "Moisture",
    thunder: "Thunder",
    date: "Date",
    precipitation: "Nedebörd"
  },

  contact: {
    title: "Contact us",
    descriptionTitle: "Sensor-Online",
    description:
      "We now it can be hard to get going, Dont hesitate to contact us and we will help you anser your questions",
    emailTitle: "Email",
    email: "info@sensor-online.se",
    phoneTitle: "Phone",
    phoneOne: "+46 (0) 500 6000 22",
    phoneTwo: "+46 (0) 733 165 100",
    locationSiencepark: "Skövde Science Park",
    locationStreet: "Kaplansgatan 16B",
    locationPostalcode: "521 32 Skövde",
    locationCountry: "Sweden"
  },

  company: {
    name: "Companyname",
    orgNumber: "Org-number",

    companyInfo: "Company information",

    addUser: "Add new user",

    invite: "Invite new user",
    inviteSent: "Invitation sent",
    inviteFailed:
      "Could not find the user, Make sure the user is registrered before!",

    fields: {
      name: "Comany name",
      orgNumber: "Org-nummer",
      postalAdress: "Postal adress",
      deliveryAdress: "Delivery adress",
      contactPhonenumber: "Contact phonenumber",
      invoiceAdress: "Email for contact",
      refrenceNmuber: "Referensnumber",
      image: "Company logotyp"
    },

    validation: {
      nameRequired: "YOU have to fill in company name",
      nameMax: "Company name must not be more than 255 chars",

      orgNumberRequired: "You have to fill in you compant VAT number",
      orgNumberFormatError: "Wrong format VAT number",

      emailRequired: "You have to fill in email address",
      emailFormatError: "Add valid email adress",

      passwordMissmatch: "Passwords does not match"
    }
  },

  report: {
    title: "Reports",
    refrenceDateDesc:
      "The reference day is the day referred to when sending a report, if the interval is monthly, select the day on which it is sent (1a each month, for example). Or weekly (which day is Mon - Fri for which the report is to be sent out).",
    create: "Create report prenumeration",
    update: "Update report prenumeration",
    exportDownload: "Report download",
    export: "Export",
    downloadFailed: "The report could not be fetch, -try again later!",
    fields: {
      name: "Report name",
      tempo: "Interval",
      createdAt: "Created",
      updatedAt: "Updated",
      id: "ID",
      refrenceDate: "Reference day",
      reportContacts: "Report contacts",
      lastSent: "The report was sent previous  "
    },

    tempo: {
      desc: {
        0: "Send the dayreport every nextcomming day 03:00",
        1: "Send the weekreport on mondays with previous week data.",
        2: "Send the month report on the 1th day of month for previous month."
      },

      0: "Daily",
      1: "Week",
      2: "Month"
    }
  },

  script: {
    name: "Scripts",
    create: "Create a newScript",
    tagsTitle: "Sensor ID and Keys",
    placeHolderContent: `   // Convert the temprature to fahrenheit 
    var tempToFahrenheit = tags["INSERT-DEVEUI"].Read("INSERT-KEY") *  9/5 + 32;
    
    // Write the new value to a new key
    tags["INSERT-DEVEUI"].Write("INSERT-NEW-KEY", tempToFahrenheit);`,
    examples: "Exempel",
    helpTitle: "Exempel och hjälp",
    exampleFarenheitTitle: "Exempel: Omvandla Celcius till Farenheit",
    exampleAverageTitle: "Exempel: Medelvärde",
    exampleAverage: `   // Get the data from three sensors
    var temp1 = tags["INSERT-DEVEUI"].Read("extTemp");
    var temp2 = tags["INSERT-DEVEUI"].Read("extTemp");
    var temp3 = tags["INSERT-DEVEUI"].Read("extTemp");

    // Write the new value to a new key
    tags["INSERT-DEVEUI"].Write("averageTemp", (temp1 + temp2 + temp3) / 3);`,
    exampleBlackIceTitle: "Exempel: Blackice detection",
    exampleBlackIce: `   var uteTemp = tags["A81758FFFE0459FB"].Read("temperature");
    var fukt = tags["A81758FFFE0459FB"].Read("humidity");
    var vagTemp = tags["A81758FFFE0459FA"].Read("temperature");

    // Set the conditions of blackice
    if (vagTemp < 2 && fukt > 75 && uteTemp > 3) {
      tags["A81758FFFE0459FA"].Write("black_ice", 1);
    } else {
      tags["A81758FFFE0459FA"].Write("black_ice", 0);
    }`,

    example420Title: "Exempel: 4-20mA korrigering",
    example420: `   // Convert the analog input value 4-20mA to the right scale
    var LowValue = 0;
    var HighValue = 200;
    var InputValue = tags["INSERT-DEVEUI"].Read("AnalogIn");

    var result = (((HighValue-LowValue)/(20 - 4)) * (InputValue - 4)) + LowValue;

    // Write the new calculated value to a new key
    tags["INSERT-DEVEUI"].Write("ActualValue", result);
     `,

    example010Title: "Exempel: 0-10V korrigering",
    example010: `   // Convert the analog input value 4-20mA to the right scale
    var LowLimit = 0;
    var HighLimit = 200;
    var InputValue = tags["INSERT-DEVEUI"].Read("AnalogIn");
    var result = (HighLimit – LowLimit) x (InputValue / 10) + LowLimit;

    tags["INSERT-DEVEUI"].Write("AnalogInCorrected", result);
    `,

    exampleMCF88Title: "Downlink for MCF88 relay",
    exampleMCF88: `downlinks.MCF88("INSERT-DEVEUI", false (or) true, "gotthardp")`,

    type: {
      0: "Loop Script",
      1: "Call   Script",
      2: "Trigered Script"
    },

    fields: {
      name: "Name",
      type: "Type",
      interval: "Interval",
      lastRun: "Last run ttime"
    },

    validation: {
      intervalRequired: "This field must be filled",
      intervalMinValue: "The minimum value for intervall is 0"
    }
  },

  user: {
    name: "User",

    email: "Email",
    role: "Role",

    userInfo: "Personal information",

    loginFailed: "Login failed",
    signInFailed: "Email/password does not match try again.",
    loginSuccessful: "Logged in ",
    updateFailed: "Update failed",
    edit: "Edit",
    forgotPassword: "Forgot password?",

    fields: {
      firstName: "First name",
      lastName: "Sure name",
      phoneNumber: "Phonenumber",
      email: "Email",
      password: "Password"
    }
  },

  application: {
    name: "Application | Applications",
    noCompanyError: "YOu must register a company first to creta applications",
    validation: {
      nameRequired: "Your application must have a name",
      nameMax: "Name must by less than 255 chars"
    },
    fields: {
      id: "ID",
      name: "Name",
      createdAt: "Created"
    }
  },

  alarm: {
    name: "Alarm",
    create: "Add new alalrm rule",
    affirmation: "Confirm",

    activeAlarm: "Alarm warnings",

    priority: {
      desc: {
        a: "Send both emal and SMS",
        b: "Send only SMS",
        c: "Send only mail notfikation"
      }
    },

    fields: {
      id: "ID",
      name: "Name",
      priority: "Priority",
      alarmDelay: "Delaytime before alarm is raised",
      active: "Alarmstatus",
      tagDataKey: "Key",
      tag: "Sensor",
      message: "Alarm message",
      limitHigh: "High treshhold",
      limitLow: "Low treshhold",
      contactType: "Kontact type",
      alarmContacts: "Alarm contacts",
      activeDays: "Days activated",
      limit: "Low and hogh alarm thresholdsåg",
      activeAlarms: "Alarm warnings",
      messageSent: "Alarm message sent"
    },

    validation: {
      nameRequired: "This filed must be filled in",
      max: "Max chars is 255"
    }
  },

  batteryStatus: {
    levels: "Batterylevel",
    value: "Value",
    lastSeen: "The latest value",
    label: "Battery Volt"
  },

  tagdata: {
    name: "Data",
    amount: "Number of data points collected:",
    notation: "{0} st",
    latestactivity: "latest activity",
    latestvalue: "Latest value",
    defaultKey: "Standard key",

    fields: {
      id: "ID",
      name: "Name",
      key: "Key",
      value: "Value",
      createdAt: "Created"
    }
  },

  tag: {
    chooseDecoder: "Choose a decoder",
    decoder: "Decoder",
    name: "Sensors",
    amount: "Number of sensors:",
    notation: "{0} st",
    details: "Sensor details",
    removeImage: "Delete image",
    chooseKey: "Choose key",
    saveKeyAsDefault: "Standard",

    tagPool: {
      tagPool: "Sensor pool",
      deveui: "Deveui",
      createdAt: "Created",
      hide: "Hide from list",
      show: "Show in default list",
      hiddenTags: "Hidden sensors",
      take: "Add sensor"
    },

    fields: {
      id: "ID",
      name: "Name",
      deveui: "DevEUI",
      appKey: "AppKey",
      appEui: "AppEUI",
      applicationId: "Application",
      profile: "Profile",
      lat: "Latitude",
      long: "Longitude",
      latAndLng: "Latitude and Longitude",
      image: "Image on sensorinstallation"
    }
  },

  validation: {
    required: "{0} must be filled in",
    max: "{0} mut be {1} charachters",
    requiredSingle: "This filed must be filled in",
    toLong: "This filed have to many characters",
    contryCodeError:
      "Dont forget that the phonumber must have countrycode (ex 4607xxxxxxxx)",
    passwordMissmatch: "Passwords does not match"
  },

  warning: {
    amount: "Activ Alarm:",
    notation: "{0} st"
  }
};
